/* eslint-disable */
(function ChatBar() {
  window.addEventListener("load", (event) => {
    var data = JSON.parse(document.querySelector('[data-chat-config]').innerHTML);
    var $chatLink = document.querySelectorAll('[data-chat-trigger]');
    var chatIcons = document.querySelectorAll('#icon-chat');
    var chatSpinners = document.querySelectorAll('#icon-chat-spinner');
    var enableCustomAgentCheck = true;
    var chatOpened = false;
    var showDebugLogs = false;

    if (typeof $chatLink !== 'undefined') {
      $chatLink.forEach(function (link) {
        link.addEventListener('click', chatLinkClick);
      });
    }

    if (typeof window.Simba === 'object' && typeof window.Simba.Cookie === 'object' && typeof window.Simba.Cookie.read === 'function') {
      chatOpened = window.Simba.Cookie.read('chat-opened');
    }

    if((data.show_chat || chatOpened === 'true') && data.settings.chat_type == 'ada') {
      logToConsole('Auto Ada Launching Chat');
      clickChat($chatLink);
    }

    if (data.settings.chat_type === 'digitalgenius') {
      loadDigitalGeniusChat();
    }

    function logToConsole(message) {
      if (showDebugLogs) {
        console.log(message);
      }
    }

    function clickChat($chatLink) {
      if ($chatLink.length > 0) {
        $chatLink[0].click();
        setIcon('inline');
        setSpinner('none');
      }
    }

    function chatLinkClick(evt) {
      if (typeof evt !== 'undefined') evt.preventDefault();
      if (data.settings.chat_type == 'ada') {
        loadAdaChat();
      } else if (data.settings.chat_type == 'digitalgenius') {
        loadDigitalGeniusChat(true);
      }
    }

    function setChatOpenedCookie(value) {
      chatOpened = Boolean(value);
      document.cookie = `chat-opened=${value}; path=/; Domain=.simbasleep.com; SameSite=Lax;`;
    }

    function loadDigitalGeniusChat(showLauncher = false) {
      if (typeof window.dgchat === 'undefined') {
        window.DG_CHAT_WIDGET_CONFIG = {
          widgetId: "3f0fd4ab-a40e-458c-958f-86056a13b5b7",
          env: "eu",
          sessionStorageMechanism: {
            mechanism: 'cookie',
            domain: 'simbasleep.com'
          },
          callbacks: {
            onWidgetEmbedded: () => {
              logToConsole('Digital Genius Embed Complete');
            },
            iframeDimensions: () => {
              window.dispatchEvent(new CustomEvent('chat:loaded'));
            },
            onChatLauncherClick: () => {
              logToConsole('Digital Genius Chat Launched');
              setChatOpenedCookie('true');
            },
            onChatEndClick: () => {
              logToConsole('Digital Genius Ended');
              setChatOpenedCookie('false');
            }
          },
          generalSettings: {
            hasDGPoweredBy: false,
            isDialogMaximised: (data.show_chat && chatOpened === 'true') ? true : false,
            isChatLauncherEnabled: (data.show_chat || chatOpened === 'true' || showLauncher) ? true : false,
            persistSession: true
          }
        };

        setIcon('none');
        setSpinner('inline');

        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = 'https://chat.digitalgenius.com/init.js';
        script.addEventListener('load', function () {
          logToConsole('Digital Genius Chat loaded');
          window.dgchat.init();

          setIcon('inline');
          setSpinner('none');
        });
        document.body.appendChild(script);
      } else {
        logToConsole('Launching Digital Genius Chat');

        window.DG_CHAT_WIDGET_CONFIG = {
          ...window.DG_CHAT_WIDGET_CONFIG,
          generalSettings: {
            ...window.DG_CHAT_WIDGET_CONFIG.generalSettings,
            isDialogMaximised: (data.show_chat && chatOpened === 'true') ? true : false,
            isChatLauncherEnabled: (data.show_chat || chatOpened === 'true' || showLauncher) ? true : false
          }
        };

        //initialise the widget
        window.dgchat.init();

        if (showLauncher) {
          setChatOpenedCookie('true');
          window.dgchat.methods.launchWidget();
        }
      }
    }

    function loadAdaChat() {
      var $script = $('#__ada');
      if ($script.length == 0) {
        setIcon('none');
        setSpinner('inline');
        if (!document.getElementById('__ada')) {
          window.adaSettings = {
            toggleCallback: (isDrawerOpen) => {
              if (typeof window.Simba === 'object' && typeof window.Simba.Cookie === 'object' && typeof window.Simba.Cookie.create === 'function') {
                window.Simba.Cookie.create('chat-opened', isDrawerOpen);
              }
            },
          }

          if (document.querySelector('[data-zendesk-locale]')) {
            var language = document.querySelector('[data-zendesk-locale]').getAttribute('data-zendesk-locale');
            window.adaSettings.language = language;
          }

          var script = document.createElement('script');
          script.id = '__ada';
          script.type = 'text/javascript';
          script.dataset.handle = "simba-sleep";
          script.src = 'https://static.ada.support/embed2.js';
          script.addEventListener('load', function () {
            onAdaChatLoaded();
          });
          document.body.appendChild(script);
        }
      } else {
        if (typeof window.adaEmbed !== 'undefined') {
          window.adaEmbed.toggle();
        }
      }
    }

    function onAdaChatLoaded() {
      setIcon('inline');
      setSpinner('none');

      if (!data.show_chat && chatOpened !== 'true' && typeof window.adaEmbed !== 'undefined') {
        window.adaEmbed.toggle();
      }
    }

    function setIcon(state) {
      chatIcons.forEach(function (icon) {
        icon.style.display = state;
      });
    }

    function setSpinner(state) {
      chatSpinners.forEach(function (spinner) {
        spinner.style.display = state;
      });
    }
  });
})();
